import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
import { colours as colourOverrides, typography } from '@domain-group/fe-co-allhomes-design-system';
export var subheading = /*#__PURE__*/css("color:", colourOverrides.text, ";", typography.mobileHeadingM, ";margin-bottom:16px;");
export var message = {
  name: "1wvv5q9",
  styles: "margin-bottom:36px;"
};
export var plannerLink = {
  name: "i3pbo",
  styles: "margin-bottom:24px;"
};
export var separator = {
  name: "i3pbo",
  styles: "margin-bottom:24px;"
};

// Constrains content that should fit the width on mobile
// But not exceed a sensible width on tablet and desktop
export var partialColumn = /*#__PURE__*/css("width:100%;", media('>=tablet'), "{width:306px;}");

// Common style for CTA buttons
export var actionButton = /*#__PURE__*/css(partialColumn, ";text-align:center;");